import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "sweetalert2/dist/sweetalert2.min.css";
import VueSweetalert2 from "vue-sweetalert2";
import VueApexCharts from "vue3-apexcharts";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

// Importar fuente Inter Variable
import "@fontsource-variable/inter";

const app = createApp(App);

app.use(VueSweetalert2);
app.component("QuillEditor", QuillEditor);
app.component("apexchart", VueApexCharts);
app.use(router);
app.mount("#app");
